import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className, y = 28, as = "div" }) {
  const reduce = useReducedMotion();
  const Comp = motion[as] || motion.div;
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </Comp>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <p
      className={`text-[11px] font-sans font-semibold uppercase tracking-[0.28em] ${
        dark ? "text-champagne" : "text-rose"
      }`}
    >
      {children}
    </p>
  );
}

export { EASE };
